import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { TransportRegistrationWithCodeComponent } from './component/transport-registration-with-code.component';
import {  ServiceResponseModule, CommonUIModule } from '@sdbn/common';
import { DictionaryModule } from '@sdbn/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { CommonTranslationModule, CommonLayoutModule } from '@sdbn/common';
import { MatFormFieldModule as MatFormFieldModule } from '@angular/material/form-field';
import { MatProgressSpinnerModule as MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { MatInputModule } from '@angular/material/input';



@NgModule({
  declarations: [
    TransportRegistrationWithCodeComponent
  ],
  imports: [
    CommonModule,

    DictionaryModule,
    FormsModule,
    ReactiveFormsModule,
    CommonTranslationModule,
    ServiceResponseModule,
    CommonLayoutModule,
    CommonUIModule,
    MatFormFieldModule,
    MatProgressSpinnerModule,
    MatInputModule
]
})
export class TransportRegistrationWithCodeModule { }
